import type { BanqueLine2, ExistingFacture3 } from "compta-shared";

type BadgeMode = ExistingFacture3["mode"] | BanqueLine2["type"];

type ModeDisplay = {
  label: string;
  className: string;
};

const badgePalette = {
  card: "text-bg-primary",
  transfer: "text-bg-info",
  directDebit: "text-bg-warning",
  cheque: "text-bg-success",
  cash: "text-bg-secondary",
  personalCard: "text-bg-dark",
  correction: "text-bg-danger",
} as const;

const modeDisplay = {
  Espèces: { label: "Espèces", className: badgePalette.cash },
  Carte1: { label: "Carte", className: badgePalette.card },
  CartePerso: { label: "Carte perso", className: badgePalette.personalCard },
  Virement1: { label: "Virement", className: badgePalette.transfer },
  Chèque1: { label: "Chèque", className: badgePalette.cheque },
  Prélèvement1: { label: "Prélèvement", className: badgePalette.directDebit },
  carte: { label: "Carte", className: badgePalette.card },
  prelevement: { label: "Prélèvement", className: badgePalette.directDebit },
  virement: { label: "Virement", className: badgePalette.transfer },
  remiseCartes: { label: "Remise cartes", className: badgePalette.card },
  remiseCheques: { label: "Remise chèques", className: badgePalette.cheque },
  remiseEspeces: { label: "Remise espèces", className: badgePalette.cash },
  cheque: { label: "Chèque", className: badgePalette.cheque },
  releveCB: { label: "Relevé CB", className: badgePalette.card },
  chequeImpaye: { label: "Chèque impayé", className: badgePalette.correction },
  correctifCheque: {
    label: "Correctif chèque",
    className: badgePalette.correction,
  },
  versement: { label: "Versement", className: badgePalette.transfer },
} satisfies Record<BadgeMode, ModeDisplay>;

interface ModeBadgeProps {
  mode: BadgeMode;
  className?: string;
}

const ModeBadge = ({ mode, className }: ModeBadgeProps) => {
  const display = modeDisplay[mode];
  const classes = ["badge", "rounded-pill", display.className, className]
    .filter(Boolean)
    .join(" ");

  return <span className={classes}>{display.label}</span>;
};

export default ModeBadge;
